import peopertyApi from "../../../api/dtl/property";

const state = {
  detail: {},
  propertyDtl: null
};

const getters = {};

const mutations = {
  // 修改收藏状态
  collect(state, { data }) {
    if (data == "no") {
      state.detail.favoritesFlag = "yes";
    } else {
      state.detail.favoritesFlag = "no";
    }
  },
  // 存房产详情
  setPropertyDtl(state, { data }) {
    state.propertyDtl = data;
  }
};

const actions = {
  // 获取房产详情
  getPropertyDtl({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.getPropertyDtlApi({ params, callback }, res => {
      callback(res);
    });
  },
  share({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.shareApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取当前房产预定销售情况列表
  getPropertyRoomLst({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.getPropertyRoomLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 提交预定信息
  submitInfo({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.submitInfo2Api({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取卡类型
  getType({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.getTypeApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取签名路径
  getSignUrl({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.getSignUrlApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取文件大小
  getPdfSize({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.getPdfSizeApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取房产详情
  getPropertyDtl2({ state }, { params, callback }) {
    console.log(state);
    peopertyApi.getPropertyDtl2Api({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dtl/property.js